<template>
  <base-material-alert
    :color="notification.msgtype == 'info' ? 'blue' : notification.msgtype == 'error' ? 'red' : 'success'"
    :icon="
      notification.msgtype == 'info'
        ? 'mdi-bell'
        : notification.msgtype == 'error'
        ? 'mdi-exclamation-thick'
        : 'mdi-check-bold'
    "
    dark
    v-if="notification.available"
  >
    <v-row>
      <v-col cols="11"><b>{{ notification.message }}</b></v-col>
      <v-col cols="1">
        <v-btn aria-label="Close" class="pr-3" color icon small @click="resetNotification">
          <v-icon>$vuetify.icon.cancel</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </base-material-alert>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "Notification",
  computed: {
    ...mapState(["notification"])
  },
  methods: {
    ...mapMutations(["RESET_NOTIFICATION"]),
    resetNotification() { 
      this.$store.commit("RESET_NOTIFICATION");
    }
  }
};
</script>
